import { environment } from './../../../environment/environment';
import { NotificationService } from './../../core/services/notification/notification.service';
import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { logoutMessage } from './../../core/models/messages';
import { AuthService } from './../../core/services/auth-service/auth.service';
import { CompanyService } from './../../core/services/company/company.service';
import { ContactService } from './../../core/services/contact/contact.service';
import { LocalStorageService } from './../../core/services/local-storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, finalize, forkJoin, Observable, of, Subject, Subscription, takeUntil, tap } from 'rxjs';
import Swal from 'sweetalert2';
import { PusherV2Service } from '@core/services/contact/pusherV2.service';
import { UserRole } from '@core/models/enums/user-role.enum';
import { SubscriptionService } from '@core/services/subscription.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})

export class HeaderComponent {
  notificationsNotRead: any;
  isMenuOpen = false;
  openMenuId: string | null = null;
  isDropdownOpen = false;
  company_id: any;
  itemsPerPage: number = 5
  currentPage: number = 1
  first_name: any;
  last_name: any;
  user: any;
  logo: any;
  image:any
  roleintervenant:any
  entreprise:any
  type: any;
  nomconsultant: any;
  name: any;
  lastnameconsultant: any;
  unreadMessageCount: number = 0;
  messages: any;
  urlimage: string = environment.baseUrlGalery;
  idCompany: any;
  idUser: any;
  url: string = environment.baseUrl;
  private unsubscribeAll: Subject<void> = new Subject();
  base_url_img = environment.baseUrlGalery;
  notificationsSubscription!: Subscription;
  unreadNotificationCount: number = 0;
  notifications: any;
  typeintervenant: string | null | number =
    this.localStorageService.getData('typeintervenant');
  firstnameinter: any;
  lastnameinter: any;
  messagesSubscription!: Subscription;
  showDropdown = false;
  showDropdownProfil = false
  showDropdownmessage = false;
  roleUser : any;
  connectedUserRole: any
  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private chatService: ContactService,
    private notificationService: NotificationService,
    private changeDetectorRef: ChangeDetectorRef,
    private companyService: CompanyService,
    private pusherV2Service: PusherV2Service,
    private subscriptionService: SubscriptionService,
  ) {

  }
  ngOnInit(): void {

    this.companyService.getAccount().subscribe((data : any) => {
       if(data){
        this.name = data.name;
        this.logo = data.logo;
       }
    });

    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    
    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}');
    this.idCompany = connectedUser?.company?.uuid
    this.idUser = connectedUser?.uuid;
    this.roleUser = connectedUser?.role_user_id; 
    this.connectedUserRole = this.checkUserRole(this.roleUser ? this.roleUser : [UserRole.INTERVENER], null)

    this.getuserById();

    this.getNotificationNotRead();

      this.pusherV2Service.listen(
        `notifications.${this.idUser}`,
        'App\\Events\\NotificationEvent',
        (notification: any) => {
          this.unreadNotificationCount++;
          this.notificationsNotRead = [notification, ...(this.notificationsNotRead || [])];
          this.changeDetectorRef.detectChanges();
        }
      );

    this.pusherV2Service.listen(
      `chat.${this.idUser}.${this.connectedUserRole ?? ''}`,
      'message.sent',
      (data: any) => {
        this.handlePusherMsg(data);
      }
    );
    this.getUnreadMessages();
  }

  getNotificationNotRead() {
    this.notificationService.getListOfNotificationNotRead().subscribe(
      {
        next: (res) => {
          this.notificationsNotRead = res.data;  
          this.unreadNotificationCount = this.notificationsNotRead?.length;
        },
        error: (e) => {
        }
      }
    );
  }
  logout() {
    this.authService.logOut();
  }
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const isDropdown = target.closest('#kt_menu_notifications');
    const isMenuTrigger = target.closest('#kt_menu_item_wow');

    if (!isDropdown && !isMenuTrigger) {
      this.closeDropdown();
    }
  }
  sessionVerification:any
  toggleDropdownProfil(): void {
    this.showDropdownProfil = !this.showDropdownProfil;
  }
  toggleMenuLink(event: Event, menuId: string) {
    event.stopPropagation();
    this.openMenuId = this.openMenuId === menuId ? null : menuId;
     if (menuId === 'wegestu' && this.roleUser[0] === 'ESNNAB') {
    event.stopPropagation();
    event.preventDefault();
    return;
  }
  }

  @HostListener('document:click', ['$event'])
  closeMenuOnOutsideClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;
    if (!targetElement.closest('.icon-notif') && !targetElement.closest('.sub-menu-notif')) {
      this.openMenuId = null;
    }
  }
  openMenu() {
    if (!this.isMobile()) {
      this.isMenuOpen = true;
    }
  }
  closeMenu() {
    if (!this.isMobile()) {
      this.isMenuOpen = false;
    }
  }
  isMobile(): boolean {
    return window.innerWidth <= 768;
  }
  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }
  toggleDropdownmessage(): void {   
    this.showDropdownmessage = !this.showDropdownmessage;
  }

  closeDropdown(): void {
    this.showDropdown = false;
  }
   viewAllNotifications(): void {
    this.navigateToNotification()
  }
  // viewAllNotifications(): void {
  //   const readRequests = this.notifications
  //     .filter((notification: any) => !notification.read)
  //     .map((notification: any) => this.readNotification(notification.id, this.notifications.indexOf(notification)));
  //   if (readRequests.length === 0) {
  //     this.closeDropdown();
  //     this.router.navigate(['/notifications']).then(() => {
  //       this.unreadNotificationCount = 0;
  //     });
  //     return;
  //   }

  //   if (this.router.url === '/notifications') {
  //     forkJoin(readRequests).pipe(
  //       finalize(() => {
  //         this.closeDropdown();
  //         window.location.reload();
  //       })
  //     ).subscribe();
  //   } else {
  //     forkJoin(readRequests).pipe(
  //       finalize(() => {
  //         this.closeDropdown();
  //         this.router.navigate(['/notifications']).then(() => {
  //           this.unreadNotificationCount = 0;
  //         });
  //       })
  //     ).subscribe();
  //   }
  // }
  viewAllChats(): void {
    this.router.navigateByUrl('/chat/chat-list')
  }
  showLogoutConfirmation() {
    Swal.fire({
      title: `${logoutMessage}`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Se déconnecter',
      confirmButtonColor: 'red',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
      iconColor: '#ff0000',
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logOut();
      } else if (result.isDismissed) {
      }
    });
  }
  logOut() {
    Swal.fire({
      title: `${logoutMessage}`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Se déconnecter',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logOut();
      } else if (result.isDismissed) {
      }
    });
  }
  currentData:any
  getuserById() {
    if (this.roleUser[0] !== 'ESNAB' &&
        this.roleUser[0] !== 'ESNNAB') {
      this.spinner.show();
      this.companyService
        .getUserById(this.idUser)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res:any) => {
            this.currentData=res?.data?.role_user_id
            this.firstnameinter = res?.body?.data?.first_name;
            this.lastnameinter = res?.body?.data?.last_name;
            this.image = res?.body?.data?.image_url;
            this.entreprise=res?.body?.data?.company_name;
            this.roleintervenant=res?.body?.data?.
            employee_role_name

            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
          },
        });
    } else {
      this.spinner.show();
      this.companyService
        .getCompanydetail(this.idCompany)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.name = res.data[0].name;
            this.type = res.data[0].type;
            this.logo = res.data[0].logo;
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
          },
        });
    }
  }

  subscribeToProfileUpdates() {
    this.companyService.profileUpdated.subscribe(() => {
      this.getuserById();
    });
  }
  startConversation(user: any) {
    this.router.navigate(['/chat/chat-list', { user: user }]);
  }



  getUnreadMessages() {
    this.chatService.getUnreadMessage(this.connectedUserRole).subscribe({
      next: (result) => {
        this.messages = (result.data || []).map((msg : any) => ({
          ...msg,
          Role: msg.Role ? msg.Role.replace(/_company\d*$/, '') : msg.Role,
        }));
        this.unreadMessageCount = this.messages.length;
      },
      error: () => {
        this.messages = [];
      }
    });
  }

  readMessage(id: any, index: number): Observable<any> {
    this.spinner.show();
    let data = { id: id };

    return this.chatService.readMessage(data).pipe(
      catchError(err => {
        return of(null); // Return an empty observable on error
      }),
      finalize(() => {
        this.spinner.hide();
        // Update the notification count and refresh notifications
        this.unreadMessageCount = this.messages.filter((messages: any) => !messages.read).length;
      }),
      tap(() => {
        // Mark the notification as read locally
        if (index >= 0 && this.messages[index]) {
          this.messages[index].read = true;
        }
      })
    );
  }

  getNotification() {
    this.company_id = this.localStorageService.getData('clientConnected');
    this.notificationService.getListOfNotification(this.company_id,this.itemsPerPage, this.currentPage).subscribe({
      next: (res) => {
        this.notifications = res.data.data.data;
        this.unreadNotificationCount = this.notifications.filter((notification: any) => notification.read === 0).length;
      },
      error: (e) => {
      },
    });
  }

  readNotification(id: any, index: number): Observable<any> {
    this.spinner.show();
    const data = { id };
   
    return this.notificationService.readNotification(data).pipe(
      catchError(err => {
        return of(null); // Return an empty observable on error
      }),
      finalize(() => {
        this.spinner.hide();       
        if (index >= 0 && this.notificationsNotRead?.length && this.notificationsNotRead[index]) {
            this.notificationsNotRead.splice(index, 1);
        }
        this.unreadNotificationCount--;
      })
    );
  }
  readNotificationall() {
    this.spinner.show();
    this.notificationService
      .readNotificationall()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.getNotification()
          this.notifications.read = true;
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
        },
      });
  }
 
  
  notificationRedirection(notification: any, index: number) {

  this.readNotification(notification.id, index).subscribe(() => {
    switch (notification.state) {
      case '1':
        this.router.navigate(['/liste-candidats']);
        break;
      case '5':
        this.router.navigate(['/consultant-externe']);
        break;
      case '6':
      case '7':
      case '11':
        this.router.navigate(['/consultants']);
        break;
      case '8':
      case '9':
        this.router.navigate(['/employee']);
        break;
      case '10':
        this.router.navigate(['/offres-emploi/candidature'], 
          {
            state : {candidateFullName: notification.sender.first_name.concat(' ', notification.sender.last_name)}
          });
        break;
      case '2':  
      case '12':
      case '19':
        this.router.navigate(['/cra']);
        break;
      case '13':
        this.router.navigate([`/entreprises/details-entreprise/${notification.sender.company_id}`]);
        break;
      case '14':
        this.router.navigate(['/evaluation/reçus']);
        break;
      case '15':
        this.router.navigate(['/evaluation/pv']);
        break;
      case '17':
      case '18':
        this.router.navigate(['/cra/liste-timesheet']);
        break;
      case '21':
        this.router.navigate(['/candidatsclientfinal']);
        break;
      // Add future redirections here if needed
      default:
        break;
    }
  });
}


  // Méthode pour déterminer l'URL cible en fonction de l'état de la notification
  getTargetUrl(notification: any): string {
    switch(notification.state) {
      case '1':
        return '/liste-candidats';
      case '5':
        return '/consultant-externe';
      case '6':
      case '7':
      case '11':
        return '/consultants';
      case '8':
      case '9':
        return '/employee';
      case '10':
        return '/offres-emploi/candidature';
      case '12':
        return '/cra';
      case '13':
        return `/entreprises/details-entreprise/${notification.sender.company_id}`;
      case '14':
        return '/evaluation/reçus';
      case '15':
        return '/evaluation/pv';
      case '17':
      case '18':
        return '/cra/liste-timesheet';
      case '19':
        return '/cra';
        case '21':
          return '/candidatsclientfinal';
      default:
        return '/accueil/notifications';
    }
  }
  navigateToNotification(){
    this.router.navigate(['/notifications']);
   this.unreadNotificationCount = 0
   this.readNotificationall()
  }

  viewMessage(userId : any) {
    const existingIndex = this.messages.findIndex((msg: any ) => msg.emitter_id === userId);

    if (existingIndex !== -1) {
      this.messages.splice(existingIndex, 1);
      this.unreadMessageCount--
    }
    this.router.navigate([
      '/chat/chat-list', { userId }
    ]).then(() => {
      this.toggleDropdownmessage()
    });
  }

  getUserImage(message: any ): string {
    const  urlUser = `${this.url}/api/User/file/gallery_users/`
    const  urlCompany = `${this.url}/api/Company/file/gallery_company/`

    if(message?.role_user_id.includes(UserRole.ADMIN_ESN)){
        return urlCompany.concat(message?.image_url)
    } else {
      return urlUser.concat(message?.image_url)
    }
  }

   subscriptionCanAccess(featureName: string): boolean {
    return this.subscriptionService.subscriptionCanAccess(featureName);
  }

  private handlePusherMsg(data : any){

    const chatMessage = {
      emitter_id : data?.emitter_id,
      Role : data?.emitter?.Role.replace(/_company\d*$/, ''),
      full_name : data?.emitter?.full_name,
      image_url : data?.emitter?.image_url,
      role_user_id : data?.emitter?.role_user_id,
      message : data?.message,
      created_at: data?.created_at
    }

    const existingIndex = this.messages.findIndex((msg: any) => msg.emitter_id === chatMessage.emitter_id);

    if (existingIndex !== -1) {
      this.messages.splice(existingIndex, 1);
    } else{
      this.unreadMessageCount++
    }
    this.messages.unshift(chatMessage);   
  }

  private checkUserRole(roles: string[], roleName : string | null): string | null {
      if (roles?.length === 1) {
        if (roles.includes(UserRole.ADMIN_ESN)) {
          return UserRole.ADMIN_ESN;
        } else if (roles.includes(UserRole.CANDIDATE)) {
          return UserRole.CANDIDATE;
        } else {
          return UserRole.INTERVENER;
        }
      }
      
      if (roles?.length === 2) {
        if (roles.includes(UserRole.CANDIDATE) && roles.includes(UserRole.CONSULTANT)) {
          return UserRole.CONSULTANT;
        } else if (roles.includes(UserRole.CANDIDATE) && roles.includes(UserRole.INTERVENER)) {
            if(roleName === 'Candidat'){
              return UserRole.CANDIDATE;
            } else{
              return UserRole.INTERVENER;
            }
        }
      }
      
      return null;
    }
  
}

